gsap.registerEffect({
  name: "fadeIn",
  effect: (targets, config) => {
    return gsap.from(targets, { duration: config.duration, opacity: config.opacity });
  },
  defaults: { duration: 2, opacity: 0 }, //defaults get applied to any "config" object passed to the effect
  extendTimeline: true, //now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
});

gsap.registerEffect({
  name: "fadeInUp",
  effect: (targets, config) => {
    return gsap.from(targets, { duration: config.duration, y: config.y, opacity: config.opacity });
  },
  defaults: { duration: 2, y:100, opacity: 0 }, //defaults get applied to any "config" object passed to the effect
  extendTimeline: true, //now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
});

gsap.registerEffect({
  name: "fadeInDown",
  effect: (targets, config) => {
    return gsap.from(targets, { duration: config.duration, y: config.y, opacity: config.opacity });
  },
  defaults: { duration: 2, y:-100, opacity: 0 }, //defaults get applied to any "config" object passed to the effect
  extendTimeline: true, //now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
});


gsap.registerEffect({
  name: "fadeInLeft",
  effect: (targets, config) => {
    return gsap.from(targets, { duration: config.duration, x: config.x, opacity: config.opacity });
  },
  defaults: { duration: 2, x:-100, opacity: 0 }, //defaults get applied to any "config" object passed to the effect
  extendTimeline: true, //now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
});

gsap.registerEffect({
  name: "fadeInRight",
  effect: (targets, config) => {
    return gsap.from(targets, { duration: config.duration, x: config.x, opacity: config.opacity });
  },
  defaults: { duration: 2, x:100, opacity: 0 }, //defaults get applied to any "config" object passed to the effect
  extendTimeline: true, //now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
});
gsap.registerEffect({
  name: "count",
  effect: (targets, config) => {
    return gsap.from(targets, { duration: config.duration, textContent:config.textContent, snap:config.snap });
  },
  defaults: { duration: 2, textContent:0, snap: { textContent: 1} }, //defaults get applied to any "config" object passed to the effect
  extendTimeline: true, //now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
});






// gsap.registerEffect({
//   name: "fadeOut",
//   effect: (targets, config) => {
//     return gsap.to(targets, { scrollTrigger: targets, duration: config.duration, opacity: 0 });
//   },
//   defaults: { duration: 2 }, //defaults get applied to any "config" object passed to the effect
//   extendTimeline: true, //now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
// });